import { render } from "./ViewPDF.vue?vue&type=template&id=1fea9d30&scoped=true"
import script from "./ViewPDF.vue?vue&type=script&lang=js"
export * from "./ViewPDF.vue?vue&type=script&lang=js"

import "./ViewPDF.vue?vue&type=style&index=0&id=1fea9d30&lang=postcss&scoped=true"

import exportComponent from "/Users/dharmik/www/pfizer-invoicing-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fea9d30"]])

export default __exports__